module.exports = __webpack_public_path__ + "8a86a961542600aecbffb8a9fc2c5de5.jpg";